import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Admin from "./Navigation/Admin";
import Employee from "./Navigation/Employee";
import Leader from "./Navigation/Leader";
import Intern from "./Navigation/Intern";

const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useSelector((state) => state.authSlice);

  // Add these console logs to debug
  console.log("Current user:", user);
  console.log("User type:", user.type);

  // Helper function to determine which navigation to show
  const getNavigation = () => {
    console.log("Getting navigation for user type:", user.type); // Debug log
    switch (user.type) {
      case "Admin":
        return <Admin />;
      case "Leader":
        return <Leader />;
      case "Employee":
        return <Employee />;
      case "Intern":
        console.log("Rendering Intern navigation"); // Debug log
        return <Intern />;
      default:
        console.log("Falling back to Employee navigation"); // Debug log
        return <Employee />;
    }
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="btn btn-dark position-fixed d-md-none"
        style={{
          top: "1rem",
          left: "1rem",
          zIndex: 1050,
          padding: "0.5rem",
        }}>
        <MenuIcon />
      </button>

      <div
        className={`main-sidebar ${isOpen ? "d-block" : "d-none"} d-md-block`}
        style={{
          top: 0,
          left: 0,
          height: "100vh",
          width: "250px",
          backgroundColor: "#fff",
          zIndex: 1051,
          overflowY: "auto",
        }}>
        <aside id="sidebar-wrapper">
          <div className="sidebar-brand flex items-center gap-2 px-4 py-2">
            <NavLink to="/home" className="w-full h-full">
              <img
                src="/logo1.jpg"
                alt="Neo HRMS Logo"
                className="object-contain"
                style={{ maxWidth: "140px", maxHeight: "140px" }}
              />
            </NavLink>
          </div>

          <div className="sidebar-brand sidebar-brand-sm">
            <NavLink to="/home">TM</NavLink>
          </div>

          {getNavigation()}

          <div className="mt-4 mb-4 p-3 hide-sidebar-mini">
            <a
              href="https://neophyte.ai/"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary btn-lg btn-block btn-icon-split">
              <i className="fas fa-rocket"></i> Neophyte.ai
            </a>
          </div>
        </aside>
      </div>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="position-fixed d-md-none"
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1040,
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default SideBar;
